
import { UserRole, ProjectStage, Priority, User, Project } from './types';
import { INITIAL_CHECKLISTS } from './constants';

export const MOCK_USERS: User[] = [
  { id: 'u1', name: 'Chand', password: 'nice123', role: UserRole.ADMIN, avatar: 'https://picsum.photos/seed/admin/100/100' },
  { id: 'u2', name: 'Sarah Designer', password: 'nice123', role: UserRole.DESIGNER, avatar: 'https://picsum.photos/seed/sarah/100/100' },
  { id: 'u3', name: 'James Dev', password: 'nice123', role: UserRole.DEV_MANAGER, avatar: 'https://picsum.photos/seed/james/100/100' },
  { id: 'u4', name: 'Emma QA', password: 'nice123', role: UserRole.QA_ENGINEER, avatar: 'https://picsum.photos/seed/emma/100/100' },
  { id: 'u5', name: 'Robert Dev', password: 'nice123', role: UserRole.DEV_MANAGER, avatar: 'https://picsum.photos/seed/robert/100/100' },
];

export const MOCK_PROJECTS: Project[] = [
  {
    id: 'p1',
    name: 'E-commerce Redesign',
    clientName: 'Luxe Fashion',
    scope: 'Complete overhaul of the existing Magento store to a modern React-based headless storefront.',
    priority: Priority.HIGH,
    stage: ProjectStage.DEVELOPMENT,
    overallDeadline: '2024-12-31',
    designDeadline: '2024-05-15',
    devDeadline: '2024-06-15',
    currentDeadline: '2024-06-15',
    assignedDesignerId: 'u2',
    assignedDevManagerId: 'u3',
    designChecklist: INITIAL_CHECKLISTS.DESIGN.map(i => ({ ...i, completed: true })),
    devChecklist: INITIAL_CHECKLISTS.DEVELOPMENT.map((i, idx) => ({ ...i, completed: idx < 3 })),
    qaChecklist: INITIAL_CHECKLISTS.QA,
    finalChecklist: INITIAL_CHECKLISTS.FINAL,
    comments: [],
    isDelayed: false,
    qaFailCount: 0,
    history: [],
    createdAt: '2024-05-01',
  },
  {
    id: 'p2',
    name: 'SaaS Dashboard v2',
    clientName: 'CloudMetrics Inc',
    scope: 'Adding predictive analytics charts and new billing module.',
    priority: Priority.URGENT,
    stage: ProjectStage.DESIGN,
    overallDeadline: '2024-10-15',
    designDeadline: '2024-06-05',
    currentDeadline: '2024-06-05',
    assignedDesignerId: 'u2',
    designChecklist: INITIAL_CHECKLISTS.DESIGN.map((i, idx) => ({ ...i, completed: idx < 4 })),
    devChecklist: INITIAL_CHECKLISTS.DEVELOPMENT,
    qaChecklist: INITIAL_CHECKLISTS.QA,
    finalChecklist: INITIAL_CHECKLISTS.FINAL,
    comments: [],
    isDelayed: true,
    qaFailCount: 0,
    history: [],
    createdAt: '2024-05-15',
  },
  {
    id: 'p3',
    name: 'Marketing Site 2024',
    clientName: 'GrowthHack Co',
    scope: 'Responsive landing page with CMS integration.',
    priority: Priority.LOW,
    stage: ProjectStage.QA,
    overallDeadline: '2024-08-01',
    currentDeadline: '2024-06-10',
    assignedDesignerId: 'u2',
    assignedDevManagerId: 'u5',
    assignedQAId: 'u4',
    designChecklist: INITIAL_CHECKLISTS.DESIGN.map(i => ({ ...i, completed: true })),
    devChecklist: INITIAL_CHECKLISTS.DEVELOPMENT.map(i => ({ ...i, completed: true })),
    qaChecklist: INITIAL_CHECKLISTS.QA.map((i, idx) => ({ ...i, completed: idx < 2 })),
    finalChecklist: INITIAL_CHECKLISTS.FINAL,
    comments: [],
    isDelayed: false,
    qaFailCount: 1,
    history: [],
    createdAt: '2024-04-20',
  }
];
